import posthog from "posthog-js";

/**
 * CLE-3015 — tour telemetry, sent through the app's PostHog client (posthog-js, initialised by
 * `usePostHog` in App.tsx). Layer 4 of spec §6: a step that breaks on a hospital configuration the tests
 * do not cover shows up as `training_step_skipped` / `training_step_stuck` with the step id and account.
 *
 * Properties are ids and counters only — never a name, a field value or anything the trainee typed.
 * When PostHog is not configured `capture` is a no-op; a throw is swallowed so telemetry can never break
 * the tour.
 */
export type TrainingTelemetryEvent =
  | "training_started"
  | "training_step_shown"
  | "training_step_skipped"
  | "training_step_stuck"
  | "training_exited"
  | "training_module_completed"
  | "training_quiz_started"
  | "training_quiz_submitted"
  | "training_certified";

export interface ITrainingTelemetryProps {
  accountId: string;
  curriculumVersion: number;
  stepId?: string;
  module?: number;
  /** `target-missing`, `not-shown` (an optional step whose element did not appear) or `no-advance`. */
  reason?: string;
  /** training_started: true when it picked up saved progress. */
  resumed?: boolean;
  /** training_quiz_submitted / training_certified: questions right in this attempt. */
  score?: number;
  /** training_quiz_submitted / training_certified: attempts so far, this one included. */
  attempts?: number;
}

export function trackTraining(
  event: TrainingTelemetryEvent,
  props: ITrainingTelemetryProps
) {
  try {
    posthog.capture(event, props);
  } catch {
    // Telemetry must never break the tour.
  }
}
